import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import preventDefault from 'shared/utils/preventDefault';
import { Input, Button } from 'shared/components';

import theme from './IdentityInfoForm.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  tooltipMessageEmail: PropTypes.node.isRequired,
  tooltipMessagePhoneNumber: PropTypes.node.isRequired,
  status: PropTypes.string.isRequired,
  phoneNumber: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  submitForm: PropTypes.func.isRequired,
};

const IdentityInfoForm = ({
  intl,
  tooltipMessageEmail,
  tooltipMessagePhoneNumber,
  status,
  email,
  phoneNumber,
  submitForm,
}) => (
  <div className={ theme.root }>
    <h2 className={ theme.title }>
      <FormattedMessage
        id="Authentication.Login.Label.MissingInfoHeader"
        defaultMessage="** You're missing some mandatory information"
      />
    </h2>

    <form
      className={ theme.form }
      onSubmit={ preventDefault(submitForm) }
    >
      <Input
        testId="identity-phone-number-field"
        defaultValue={ phoneNumber.value }
        placeholder={{ id: 'General.PhoneNum', defaultMessage: '** Phone Number' }}
        iconName="phone"
        iconPositionLeft={ true }
        iconPositionRtlNotReversed={ true }
        size="large"
        mediaResized={ true }
        status={ phoneNumber.status }
        greenSuccessStatus={ true }
        disabled={ phoneNumber.isDisabled }
        onChange={ phoneNumber.onChange }
        onFocus={ phoneNumber.onFocus }
        autoFocus={ true }
        required={ true }
        type="text"
        tooltipTestId="identity-form-phone-tooltip"
        tooltipMessage={ tooltipMessagePhoneNumber }
      />

      <Input
        testId="identity-email-field"
        defaultValue={ email.value }
        placeholder={{ id: 'General.Email', defaultMessage: '** Email' }}
        iconName="envelope-grey"
        iconPositionLeft={ true }
        iconPositionRtlNotReversed={ true }
        size="large"
        mediaResized={ true }
        status={ email.status }
        greenSuccessStatus={ true }
        disabled={ email.isDisabled }
        onChange={ email.onChange }
        onFocus={ email.onFocus }
        autoFocus={ true }
        required={ true }
        type="text"
        tooltipTestId="identity-form-email-tooltip"
        tooltipMessage={ tooltipMessageEmail }
      />

      <Button
        testId="identity-submit-button"
        label={ intl.formatMessage({ id: 'General.Submit', defaultMessage: '** Submit' }) }
        iconName="arrow-right"
        isLoading={ status === requestsStatuses.pending }
        size="large"
        disabled={ status === requestsStatuses.pending || status === requestsStatuses.success }
        type="submit"
        mediaResized
        fullWidth
      />
    </form>
  </div>
);

IdentityInfoForm.propTypes = propTypes;

export default IdentityInfoForm;
